<script setup lang="ts">
defineProps(
  {
    showDivider: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  }
);
</script>

<template>
  <v-row dense :no-gutters="dense">
    <v-col cols="4" :align-self="dense ? 'center' : 'start'">
      <span class="font-weight-bold"><slot name="name"/></span>
      <p class="text-blue-grey">
        <slot name="comment"/>
      </p>
    </v-col>
    <v-col cols="8" class="text-right a">
      <slot/>
    </v-col>
  </v-row>
  <v-row v-if="showDivider" dense>
    <v-col>
      <v-divider class="mb-2"/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
